import { bool, object, string, func } from 'prop-types';
import React from 'react';
import { PageStrings } from '@alltrails/shared/utils/pageStringHelpers';
import UserPropType from '../../../../proptypes/UserPropType';
import LanguageRegionCodePropType from '../../../../proptypes/LanguageRegionCodePropType';

import StatSection from '../StatsSection/StatsSection';
import StaticMapImage from '../../../MapCreator/StaticMapImage';
import { MapStatsUtil } from '../../../../utils/map_stats_util';
import { ServerCommunicationUtil } from '../../../../utils/server_communication_util';
import { StringConstantsMixin } from '../../../../application/javascripts/react_components/mixins/shared/string_constants_mixin';

import * as styles from './styles/styles.module.scss';

const StatsTab = ({ data, currentPage, displayMetric, currentUser, languageRegionCode, isMobileWidth, showMapMobile }) => {
  const getPaceOrSpeed = (stats, metric) => {
    if (currentUser && currentUser.displaySpeed) {
      const mapAvgSpeedVal = MapStatsUtil.avgSpeed(stats, metric);
      const mapAvgSpeed = MapStatsUtil.speedFormatted(mapAvgSpeedVal, metric, languageRegionCode);
      return {
        label: StringConstantsMixin.strings.STATS.NORMAL.AVG_SPEED,
        value: mapAvgSpeed
      };
    }
    const mapAvgPaceVal = MapStatsUtil.avgPace(stats, metric);
    const mapAvgPace = MapStatsUtil.timeFormatted(mapAvgPaceVal, metric);
    return {
      label: StringConstantsMixin.strings.STATS.NORMAL.AVG_PACE,
      value: mapAvgPace
    };
  };

  const nA = '--';
  let mapTotalDistance = nA;
  let mapElevationGain = nA;
  let mapMovingTime = nA;
  let mapTotalTime = nA;
  let mapCalories = nA;
  let mapPaceOrSpeed = {
    label: nA,
    value: nA
  };

  const stats = data.summaryStats;
  if (stats) {
    const metric = displayMetric;
    mapTotalDistance = MapStatsUtil.metersToFormattedUserUnits(stats.distanceTotal, 2, metric, languageRegionCode);
    mapElevationGain = MapStatsUtil.elevationFormatted(stats.elevationGain, metric, languageRegionCode);
    mapMovingTime = MapStatsUtil.timeFormatted(stats.timeMoving);
    mapTotalTime = MapStatsUtil.timeFormatted(stats.timeTotal);
    mapCalories = MapStatsUtil.caloriesFormatted(stats.calories, languageRegionCode);
    mapPaceOrSpeed = getPaceOrSpeed(stats, metric, languageRegionCode);
  }

  return (
    <div className={styles.statsContainer}>
      <div className={styles.statsSection}>
        <StatSection labelName={StringConstantsMixin.strings.FILTERS.LENGTH} data={mapTotalDistance} />
        <StatSection labelName={StringConstantsMixin.strings.STATS.NORMAL.ELEVATION_GAIN} data={mapElevationGain} />
        {currentPage !== PageStrings.EXPLORE_USERS_MAPS_MAP_PAGE && (
          <StatSection labelName={StringConstantsMixin.strings.STATS.NORMAL.MOVING_TIME} data={mapMovingTime} />
        )}
      </div>
      {currentPage !== PageStrings.EXPLORE_USERS_MAPS_MAP_PAGE && (
        <div className={styles.statsSection}>
          <StatSection labelName={mapPaceOrSpeed.label} data={mapPaceOrSpeed.value} />
          <StatSection labelName={StringConstantsMixin.strings.STATS.NORMAL.CALORIES} data={mapCalories} />
          <StatSection labelName={StringConstantsMixin.strings.STATS.NORMAL.TOTAL_TIME} data={mapTotalTime} />
        </div>
      )}
      {isMobileWidth && (
        <div className={styles.staticMapImage}>
          <StaticMapImage
            url={`/api/alltrails/maps/${data.id}/static_map?size=480x200&key=${ServerCommunicationUtil.apiKey}`}
            onClick={showMapMobile}
          />
        </div>
      )}
    </div>
  );
};

StatsTab.propTypes = {
  data: object.isRequired,
  currentPage: object,
  displayMetric: bool.isRequired,
  currentUser: UserPropType,
  languageRegionCode: LanguageRegionCodePropType.isRequired,
  isMobileWidth: bool,
  showMapMobile: func
};

StatsTab.defaultProps = {
  currentPage: {},
  currentUser: {},
  isMobileWidth: false,
  showMapMobile: () => {}
};

export default StatsTab;
